import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  mixins: [mixFormatoEstructura],
  data() {
    return {
      dato: '',
    };
  },
  methods: {
    formatoObjeto(objeto) {
      return this.formatoEstructura(objeto, false, true);
    },
    formatoWordObrasSolicitudes(datosSolicitud) {
      if (!datosSolicitud || typeof (datosSolicitud) !== 'object') return {};
      const solicitudMap = new Map();
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(datosSolicitud)) {
        switch (key) {
          case 'numeroMemorandum':
            if (!value) { break; }
            solicitudMap.set(key, `${value}`);
            break;
          case 'meta':
            if (!value) { break; }
            solicitudMap.set('metaSolicitud', `${value}`);
            break;
          case 'fuenteFinanciera':
            if (!value) { break; }
            solicitudMap.set('fuenteFinanciera', `${value.nombre}`);
            break;
          case 'fechaInicioObra':
            if (!value) { break; }
            solicitudMap.set('fechaInicioObra', `${value}`);
            solicitudMap.set('mesInicioObra', this.formatoFechaSeparador(`${value}`, { letra: true }).split('/')[1] || '');
            break;
          default:
            if (!value && value !== 0) { solicitudMap.set(key, ''); break; }
            solicitudMap.set(key, value);
            break;
        }
      }
      return this.formatoObjeto(Object.fromEntries(solicitudMap));
    },
  },
};
